module.exports = __webpack_public_path__ + "media/images/pa_main_schedule_logo-fe2eccda3ede1a2de37a9471924c3f33.svg";